import React from 'react';
import { Package, CheckCircle2, ArrowDown } from 'lucide-react';
import styles from './ProductHero.module.css';

const ProductHero = () => {
  const handleCatalogDownload = () => {
    const catalogPath = '/catalog/greeneripapers-catalog.pdf';
    const link = document.createElement('a');
    link.href = catalogPath;
    link.download = 'greeneripapers-catalog.pdf';
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <section className={styles.heroWrapper}>
      {/* Decorative Plus Grid Pattern from Image */}
      <div className={styles.plusGrid}>
        {[...Array(12)].map((_, i) => <span key={i}>+</span>)}
      </div>

      {/* Geometric Background Shapes */}
      <div className={styles.bgShape}></div>

      <div className={styles.container}>
        {/* Left Side: Content */}
        <div className={styles.contentSide}>
          <div className={styles.badge}>
            <Package size={16} /> <span>Product Catalog 2026</span>
          </div>

          <h1 className={styles.mainTitle}>
            Our Premium <br />
            <span className={styles.accentText}>Product Range</span>
          </h1>

          <p className={styles.description}>
            At Greeneri Papers, we engineer high-performance sustainable paper 
            solutions that cater to diverse industrial needs. Our products 
            combine raw strength with 100% recyclability, ensuring your business 
            meets its goals without environmental compromise.
          </p>

          <p className={styles.subDescription}>
            From premium kraft paper to custom-textured packaging solutions, 
            every product is a result of chemical-free pulping and advanced 
            eco-friendly manufacturing processes.
          </p>

          <div className={styles.featureList}>
            <div className={styles.featureItem}>
              <CheckCircle2 size={18} color="#ff671b" />
              <span>Industrial Grade Durability</span>
            </div>
            <div className={styles.featureItem}>
              <CheckCircle2 size={18} color="#ff671b" />
              <span>Certified Carbon-Neutral</span>
            </div>
          </div>

          <button className={styles.scrollBtn} type="button" onClick={handleCatalogDownload}>
            Download Catelog <ArrowDown size={18} />
          </button>
        </div>

        {/* Right Side: Image Side with Reference Styling */}
        <div className={styles.imageSide}>
          <div className={styles.imageFrame}>
            <img 
              src="/images/products/Cup-Bottoms1 (3).png" 
              alt="Premium Paper Product" 
              className={styles.productImg}
            />
          </div>
          {/* Decorative small boxes like the UI reference */}
          <div className={styles.decorBox}></div>
        </div>
      </div>
    </section>
  );
};

export default ProductHero;